
































































































































































import { Component, Vue } from "vue-property-decorator";
import { waitPaymentList, paymemt, paymemtAll } from "@/req/moneyTx";
import headerTitle from "@/components/headerTitle.vue";
import txIssueModel from "./model/txAuditModel.vue";
import allAuditModel from "./model/allAuditModel.vue";
import traceOrder from "./model/traceOrder.vue";
import exportTab from "./model/exportTab.vue";
@Component({
  components: {
    headerTitle,
    txIssueModel,
    allAuditModel,
    traceOrder,
    exportTab,
  },
})
export default class Home extends Vue {
  public account: any = "";
  public typeLimit = 0;
  public disableShow = false;
  public orderNum = 0;
  public uid: any = "";
  public typeList: any = [
    {
      id: 2,
      name: "交易币",
    },
    {
      id: 1,
      name: "金币",
    },
  ];
  public page = 1;
  public size = 10;
  public loading = false;
  public options = {
    disabledDate(date) {
      return date && date.valueOf() > Date.now();
    },
  };
  public columns = [
    {
      width: 75,
      title: "ID",
      key: "id",
      align: "center",
      fixed: "left",
    },
    {
      width: 110,
      title: "提现时间",
      key: "apply_time",
      align: "center",
      render: (h, params) => {
        return h("span", this.$fn.toDateSymbol(params.row.apply_time));
      },
      fixed: "left",
    },
    {
      width: 120,
      title: "提现盒子号 (UID)",
      slot: "account",
      align: "center",
      fixed: "left",
      // render: (h, params) => {
      //   return h("span", `${params.row.account} (${params.row.uid})`);
      // },
    },
    {
      width: 100,
      title: "提现金额",
      slot: "total_extract_money",
      align: "center",
    },
    {
      width: 130,
      title: "手续费(人民币)",
      key: "extarct_charge_money",
      align: "center",
    },
    {
      width: 100,
      title: "当前状态",
      slot: "color",
      align: "center",
    },
    {
      width: 100,
      title: "提现手续费抵扣劵",
      key: "use_coupon_money",
      align: "center",
    },
    {
      width: 105,
      title: "可提现",
      key: "trade_coin",
      align: "center",
    },
    {
      width: 140,
      title: "已提现到支付宝",
      key: "all_total_extract_money_alipay",
      align: "center",
    },
    {
      width: 140,
      title: "已提现到盒币",
      key: "all_total_extract_money_box_coin",
      align: "center",
    },
    // {
    //   width: 105,
    //   title: "已提现",
    //   key: "all_total_extract_money",
    //   align: "center",
    // },
    {
      width: 95,
      title: "已提现 手续费总",
      key: "all_extarct_charge_money",
      align: "center",
    },
    {
      width: 120,
      title: "交易币支出",
      key: "all_trade_coin_pay",
      align: "center",
    },
    {
      width: 110,
      title: "订单总金额",
      slot: "total_amount",
      align: "center",
    },
    {
      width: 145,
      title: "提现支付宝账号",
      key: "alipay_account",
      align: "center",
    },
    {
      width: 125,
      title: "绑定手机号",
      key: "phone",
      align: "center",
    },
    {
      width: 110,
      title: "状态",
      key: "status",
      slot: "status",
      align: "center",
    },
    {
      width: 120,
      title: "审核人",
      key: "approve_username",
      align: "center",
    },
    {
      width: 150,
      title: "提现IP",
      key: "ip",
      align: "center",
    },
    {
      width: 150,
      title: "提现设备",
      key: "device",
      align: "center",
    },
    {
      width: 280,
      title: "操作",
      key: "action",
      slot: "action",
      align: "center",
      fixed: "right",
    },
  ];
  public data: any = [];
  public addType(index) {
    // if (this.typeLimit == index) {
    //   return false
    // }
    this.page = 1;
    this.typeLimit = index;
    this.getList();
  }
  public mounted() {
    this.getList();
  }
  public query() {
    this.page = 1;
    this.getList();
  }
  public change(i) {
    this.page = i;
    this.getList();
  }
  public async getList() {
    this.loading = true;
    const obj: any = {
      type: this.typeList[this.typeLimit].id,
      page: this.page,
      pagenum: this.size,
      account: this.account,
      uid: this.uid,
    };
    const res = await waitPaymentList(obj);
    if (res.code == 0) {
      this.data = res.data.list;
      this.disableShow = res.data.status == 1 ? true : false;
      this.orderNum = res.data.count;
      if (this.disableShow && res.data.count == 0) {
        this.disableShow = false;
      }
      this.loading = false;
    }
  }
  public submit(shows, row) {
    const $txIssueModel: any = this.$refs.txIssueModel;
    $txIssueModel.show(shows, row);
  }
  public childSubmit(shows, arr, content) {
    if (shows) {
      this.getAuditExtract(1, arr, "");
    } else {
      this.getAuditExtract(2, arr, content);
    }
  }
  public async getAuditExtract(typeId, arr, content) {
    // this.typeList[this.typeLimit].id
    const res = await paymemt({
      type: typeId,
      id_arr: arr,
      tips: content,
    });
    if (res.code == 0) {
      this.getList();
      this.$Message.success(res.msg);
    }
  }
  // 溯源订单
  public addTraceOrder(row) {
    const $traceOrder: any = this.$refs.traceOrder;
    $traceOrder.show(row);
  }
  // 一键同意
  public addSave() {
    const arr: any = [];
    this.data.data.forEach((item) => {
      arr.push(item.id);
    });
    const $allAuditModel: any = this.$refs.allAuditModel;
    $allAuditModel.show(true, arr);
  }
  // 一键同意返回数据
  public childSubmits(shows, arr, content) {
    if (shows) {
      this.getAuditExtract(1, arr, "");
    } else {
      this.getAuditExtract(2, arr, content);
    }
  }
  // 全部一键同意
  public addSaves() {
    const $allAuditModel: any = this.$refs.allAuditModel;
    $allAuditModel.show(true, "", true);
  }
  // 全部一键同意返回数据
  public async allSaveSubmit() {
    const res = await paymemtAll({
      type: 1,
    });
    if (res.code == 0) {
      this.$Message.success(res.msg);
      this.page = 1;
      this.getList();
    }
  }
  // 表格导出
  public getExport() {
    const $exportTab: any = this.$refs.exportTab;
    $exportTab.show(4);
  }
  // 是否标红
  public returnColorShow(row) {
    const str: any = Number(row.trade_coin);
    const num = Number(row.total_extract_money);
    return num <= str ? true : false;
  }
}
